import { motion } from 'motion/react';
import { useInView } from '../../../components/hooks/useInView.jsx';

export function OverviewSection() {
  const [ref, isInView] = useInView({ threshold: 0.2 });

  const features = [
    'Personalized workout plans for every fitness level.',
    'Smart meal suggestions tailored to user dietary preferences.',
    'Comprehensive tracking of workouts, meals, and sleep patterns.',
    'User-friendly interface with engaging progress visuals.'
  ];

  return (
    <section ref={ref} className="min-h-screen flex items-center py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={isInView ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-5xl md:text-6xl mb-8">
            Overview
          </h2>
          <div className="h-1 w-20 bg-[#fd5b38] mb-12" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mb-16"
        >
          <p className="text-xl md:text-2xl text-gray-300 leading-relaxed mb-8">
            In today's fast-paced world, many individuals find it challenging to prioritize their health and wellness. 
            Balancing fitness routines, nutritious meal planning, and adequate sleep often feels overwhelming, especially 
            when existing tools fail to provide an integrated, personalized experience.
          </p>
          <p className="text-xl md:text-2xl text-gray-300 leading-relaxed">
            Our conceptual fitness tracker app is designed to revolutionize how users approach their wellness journeys. 
            This App bridges the gap between fragmented fitness solutions by offering a holistic platform that integrates 
            personalized workouts, meal suggestions tailored to dietary preferences, and comprehensive activity and sleep tracking.
          </p>
        </motion.div>

        <div>
          <motion.h3
            initial={{ opacity: 0, x: -30 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="text-3xl md:text-4xl mb-8 text-[#fd5b38]"
          >
            Key Features
          </motion.h3>
          
          <div className="space-y-4">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -30 }}
                animate={isInView ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.6, delay: 0.5 + index * 0.1 }}
                className="flex items-start gap-4"
              >
                <div className="w-2 h-2 bg-[#fd5b38] rounded-full mt-3 flex-shrink-0" />
                <p className="text-lg md:text-xl text-gray-300">{feature}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
